import { splitCurrency } from "utils";
import styled from "styled-components";

const Dollars = styled.span`
  font-size: 2rem;
`;

const StyledCurrency = ({ amount, className }) => {
  const [dollars, cents] = splitCurrency(amount);
  return (
    <div className={className}>
      $<Dollars>{dollars}</Dollars>.{cents}
    </div>
  );
};

export default StyledCurrency;
